import Cabecalho from "../../components/Cabecalho";
import { Outlet } from "react-router-dom";
import Rodape from "../../components/Rodape";
import styled from "styled-components";

const Container = styled.section`
  max-width: 100%;
  overflow-x: hidden;
`

export default function PaginaBase() {
    return (
        <Container>
        <Cabecalho />
        <main>
            <Outlet />
        </main>
        <Rodape />
        </Container>
    )
}